import { Injectable } from '@angular/core';
import { delay } from '../_helpers/delay';

@Injectable({
  providedIn: 'root',
})
export class ReloadService {
  public reloading = false;

  constructor() {}

  public reloadPage(): void {
    this.reloading = true;
    window.location.reload();
  }

  public async reloadPageTimeout(msTillReload: number): Promise<void> {
    await delay(msTillReload);
    this.reloading = true;
    window.location.reload();
  }
}
